import React from 'react'
import { connect } from 'react-redux'
import FormGroup from 'components/form-components/form-group'
import { Button } from 'components/styled/button'
import { mapLanguageToComponentProps } from 'interview/i18n'
import AgreeTos from 'components/agree-tos'
import CandidateForm from 'interview/components/candidate-form'
import Layout from 'interview/components/layout'
import { Body, H2, Hr, Subtitle } from 'components/styled/typography'
import ActionBarWrapper from 'components/action-bar-wrapper'
import { CardGroup } from 'components/styled/card-group'
import Question from 'components/question'
import { formatDateTimeTimezone } from 'utils/date'
import { I18nComponentType } from 'interview/i18n-types'
import { PositionType } from 'types'

interface PublicInterviewProps {
  interview: PositionType
  candidate: { agreeTOS: boolean }
  onSubmit: any
  onChange: any
  model?: string
  i18n: I18nComponentType
  disableEmail?: boolean
  videoEventProps?: any
}

const PublicInterview = ({
  interview,
  candidate,
  onSubmit,
  onChange,
  model = 'candidate',
  i18n,
  disableEmail = false,
  videoEventProps,
}: PublicInterviewProps) => {
  const { questions, endTime, company } = interview

  return (
    <Layout
      size="small"
      jobOpening={model === 'previewCandidate' ? interview : undefined}
    >
      <H2 mb="s40" color="bodyText">
        {i18n.interview.title}
      </H2>
      <CandidateForm
        onChange={onChange}
        model={model}
        disableEmail={disableEmail}
        formName="publicInterviewForm"
        isPublic
        onSubmit={onSubmit}
      >
        <FormGroup
          /* @ts-ignore */
          model={`${model}.agreeTOS`}
        >
          <AgreeTos
            model={`${model}.agreeTOS`}
            agreed={candidate.agreeTOS}
            onChange={(value: boolean) => onChange(`${model}.agreeTOS`, value)}
            privacyLink={company?.privacyPolicy}
          />
        </FormGroup>
        <ActionBarWrapper
          hideBeforeScroll
          leftSideComponent={
            endTime && (
              <Body fontWeight={600}>
                {i18n.layout.endTime(formatDateTimeTimezone(endTime))}
              </Body>
            )
          }
          actions={
            <Button
              text={i18n.interview.startInterview}
              iconRight={interview.language === 'ar' ? 'west' : 'east'}
              // @ts-ignore
              onClick={() => document.publicInterviewForm.submit()}
            />
          }
        />
      </CandidateForm>
      <Hr />
      <Subtitle>{i18n.interview.preview}</Subtitle>
      <CardGroup minWidth="s320">
        {questions &&
          questions.map(question => (
            <Question
              key={question._id}
              question={question}
              videoEventProps={videoEventProps}
              locationId="publicInterviewPage"
            />
          ))}
      </CardGroup>
    </Layout>
  )
}

export default connect(mapLanguageToComponentProps())(PublicInterview)
